"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreeRoundBonusType = exports.CasinoProvider = exports.CasinoGameTag = exports.CasinoBetStatus = exports.CasinoTransactionType = void 0;
var CasinoTransactionType;
(function (CasinoTransactionType) {
    CasinoTransactionType["debit"] = "debit";
    CasinoTransactionType["credit"] = "credit";
    CasinoTransactionType["rollback"] = "rollback";
})(CasinoTransactionType || (exports.CasinoTransactionType = CasinoTransactionType = {}));
var CasinoBetStatus;
(function (CasinoBetStatus) {
    CasinoBetStatus["Pending"] = "Pending";
    CasinoBetStatus["Loss"] = "Loss";
    CasinoBetStatus["Win"] = "Win";
    CasinoBetStatus["RollbackVoid"] = "RollbackVoid";
    CasinoBetStatus["RollbackLoss"] = "RollbackLoss";
})(CasinoBetStatus || (exports.CasinoBetStatus = CasinoBetStatus = {}));
var CasinoGameTag;
(function (CasinoGameTag) {
    CasinoGameTag["Top"] = "Top";
    CasinoGameTag["Hot"] = "Hot";
    CasinoGameTag["Popular"] = "Popular";
    CasinoGameTag["New"] = "New";
    CasinoGameTag["DropsAndWins"] = "Drops&Wins";
    CasinoGameTag["Featured"] = "Featured";
    CasinoGameTag["CrashGame"] = "CrashGame";
    CasinoGameTag["Football"] = "Football";
    CasinoGameTag["VFX"] = "VFX";
    CasinoGameTag["CGFX"] = "CGFX";
})(CasinoGameTag || (exports.CasinoGameTag = CasinoGameTag = {}));
var CasinoProvider;
(function (CasinoProvider) {
    CasinoProvider["PGSoft"] = "PG Soft";
    CasinoProvider["Spribe"] = "Spribe";
})(CasinoProvider || (exports.CasinoProvider = CasinoProvider = {}));
var FreeRoundBonusType;
(function (FreeRoundBonusType) {
    FreeRoundBonusType["Manual"] = "Manual";
    FreeRoundBonusType["OneTime"] = "OneTime";
    FreeRoundBonusType["Repeatable"] = "Repeatable";
    FreeRoundBonusType["Daily"] = "Daily";
})(FreeRoundBonusType || (exports.FreeRoundBonusType = FreeRoundBonusType = {}));
//# sourceMappingURL=casino.js.map